import {Injectable, EventEmitter, Output} from '@angular/core';
import {UserSession, HttpOptions} from "../../modele/authModel";
import {NGXLogger} from "ngx-logger";
import {HttpClient} from "@angular/common/http";
import {BackendService} from "../api/backend.service";
import {Observable, of} from "rxjs";
import {
    SearchBoardBackendResponse, SearchBoard, Board, CreateNewBoard,
    backendApiInputCreateNewBoardWrapper, EditExistingBoard
} from '../../modele/boardModel';
import {DelayService} from "../delay.service";
import {CookieService} from 'ngx-cookie-service';
import { User, Owner} from '../../modele/user/userModel';
import { ISubscription } from "rxjs/Subscription";
import {UserService} from "../user.service";
import {Event, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError} from "@angular/router";
import {HttpHeaders} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class EndpointService {

    local_http_opts:HttpOptions;
    private log_prefix=this.constructor.name+":";
    private current_user_session:UserSession=new UserSession();
    @Output() returnFollowerUnreadCount: EventEmitter<boolean> = new EventEmitter();
    @Output() returnCreateBoardPostIsDone: EventEmitter<boolean> = new EventEmitter();
    @Output() returnCommentUnreadCount: EventEmitter<boolean> = new EventEmitter();
    @Output() returnloginState: EventEmitter<boolean> = new EventEmitter();
    @Output() isReadyState: EventEmitter<boolean> = new EventEmitter();
    @Output() returnLocalUser: EventEmitter<User> = new EventEmitter();
    @Output() loadisready: EventEmitter<boolean> = new EventEmitter();
    loginState: boolean;
    private dataSubscription: ISubscription;
    private userResolutionEmitter:EventEmitter<User>=new EventEmitter<User>();
    session_user:User = new User(-1,"","");


    constructor(
        private sessionService: DelayService,
        private logger: NGXLogger,
        private http:HttpClient,
        private bes:BackendService,
        private cookieService: CookieService,
        private userService: UserService,
        private router: Router,

    ) {
        this.logger.info(this.log_prefix,"cons called");
        this.userService.getUserSessionSubject().subscribe(userSession => {
            this.logger.info(this.log_prefix, "service provided userSession:ttl:", userSession.ttl);
            this.current_user_session = userSession;
            if(userSession.ttl > 0){
                this.logger.info(this.log_prefix,"have valid session -> creating http opts");
                this.local_http_opts = new HttpOptions(userSession)
            }
        });

        this.userService.getUserSubject().subscribe(user => {
            this.logger.info(this.log_prefix,"got informed of user:",user.user_id);
            this.userResolutionEmitter.emit(this.session_user);
            this.session_user = user;
            this.loginState = true;
        });

        this.sessionService.getSessionIsReadyEmitter().subscribe((sessionHasBegun)=>{
        })

    }

    httpsOpts(){
        return this.local_http_opts;
    }

    deleteUsserSession(){
        this.returnloginState.emit(false);
    }
    getUserLoginStateEmitter():EventEmitter<boolean>{
        return this.returnloginState;
    }
    getLocalUserEmitter():EventEmitter<User>{
        return this.userResolutionEmitter;
    }

    getLocalUserState():Observable<boolean> {
        return new Observable((observer) => {
            return observer.next(this.loginState);
        });
    }
    getState(){
        this.getUserLoginStateEmitter().subscribe(data=>{
            return data
        })
    }
    getloadisreadyEmitter():EventEmitter<boolean>{
        return this.loadisready;
    }
    getBoardByNameForBoardPage(board_name:string){
        return this.http.get(this.bes.getBackendBoardByNameUrl()+board_name, this.local_http_opts);
    };
    isValidToken(){
        return this.http.get(this.bes.getBackendTokenIsValidUrl(), this.local_http_opts);
    };
    getBoardByName(board_name:string){
        return new Observable((observer)=>{
            this.sessionService.waitForSessionStart().subscribe((sessionHasBegun)=>{
                observer.next(this.http.get(this.bes.getBackendBoardByNameUrl()+board_name, this.local_http_opts));
            });
    });}
    getBackendUserIDByNameUrl(user_name:string){
        return this.http.post(this.bes.getBackendUserIDByNameUrl(),{user_name}, this.local_http_opts);
    }
    updateUserStatus(user_status:string, user_id:number){
        return this.http.post(this.bes.getBackendupdateUserStatus(),{ user_status, user_id}, this.local_http_opts).subscribe(newStatus=>{
            this.userService.serviceInterfaceToInformOfChanges().next(this.log_prefix);

        })
    }
    getBackendgetTopicsForUserID(){
        return this.http.get(this.bes.getBackendgetTopicsforUser(), this.local_http_opts);
    }
    getBackendgetAllTopics(){
        return this.http.get(this.bes.getBackendAllTopics(), this.local_http_opts);
    }
    getBackendFollowState(board_id:string){
        return this.http.post(this.bes.statusFollowBoard(),{board_id}, this.local_http_opts);
    }
    getBackendFollowerCountForBoard(board_id:number){
        return this.http.post(this.bes.getBackendgetFollowerCount(),{board_id}, this.local_http_opts);
    }
    getBackendnewFollowerCountForUser(user_id:number){
        return this.http.post(this.bes.getBackendgetFollowerCountForUser(),{user_id}, this.local_http_opts);
    }
    getHitsForBoard(board_id:number){
        return this.http.post(this.bes.getHitCountForBoard(),{board_id}, this.local_http_opts);
    }
    getUserByID(user_id:number){
        return this.http.get(this.bes.getBackendUserByIDUrl(user_id ), this.local_http_opts);
    }
    getBackendAllRelatedBoardsUrlForUserID(user_id:number){
        return this.http.get(this.bes.getBackendAllRelatedBoardsUrlForUserID(user_id), this.local_http_opts);
    }
    getAllForSearch(){
        return this.http.get(this.bes.getBackendGetAllForSearchUrl(), this.local_http_opts);
    }
    getAllBoardsForLocaluser(){
        return this.http.get(this.bes.getBackendGetAllForBoardsForLocalUser(), this.local_http_opts);
    }
    getFollowerCountForBoardID(board_id){
        return this.http.post(this.bes.getBackendFollowerForBoardID(),{board_id}, this.local_http_opts);
    }
    getHitsCountForBoardID(board_id){
        return this.http.post(this.bes.getBackendHitsForBoardID(),{board_id}, this.local_http_opts)
    }
    getCommentCountForBoardID(board_id){
        return this.http.post(this.bes.getBackendCommentCountForBoardID(),{board_id}, this.local_http_opts);
    }
    getNewHitForBoardID(board_id){
        return this.http.post(this.bes.getBackendgetNewHitsForBoardID(),{board_id}, this.local_http_opts).subscribe(data => {
        })
    }
    updateUserLevel(user_id, user_level){
        return this.http.post(this.bes.getBackendUpdateUserLevel(user_id), {user_level}, this.local_http_opts).subscribe(data => {
        })
    }

    startTopicRelation(topic_id){
        return this.http.post(this.bes.getBackendStartTopic(),{topic_id}, this.local_http_opts).subscribe(topic => {
        })
    }
    stopTopicRelation(topic_id){
        return this.http.post(this.bes.getBackendStopTopic(),{topic_id}, this.local_http_opts).subscribe(topic => {
        })
    }
    statusTopicRelation(topic_id){
        return this.http.post(this.bes.getBackendStatusTopic(),{topic_id}, this.local_http_opts)
    }
    updateUserNotificationFollow(user_id, trueorfalse){
        return this.http.post(this.bes.getBackendsetFollowNotification(),{user_id, trueorfalse}, this.local_http_opts).subscribe(data => {
        })
    }
    updateNotificationStatusChangeFollow(user_id, board_id){
        return this.http.post(this.bes.getBackendupdateFollowStatus(),{user_id, board_id}, this.local_http_opts).subscribe(data => {
        })
    }
    updateNotificationStatusChangeComment(user_id, board_id){
        return this.http.post(this.bes.getBackendupdateCommentStatus(),{user_id, board_id}, this.local_http_opts).subscribe(data => {
        })
    }
    updateUserNotificationComment(user_id, trueorfalse){
        return this.http.post(this.bes.getBackendsetCommentNotification(),{user_id, trueorfalse}, this.local_http_opts).subscribe(data => {
        })
    }
    updateUserProfilPrivacy(user_id, trueorfalse){
        return this.http.post(this.bes.getBackendsetProfilPrivacy(),{user_id, trueorfalse}, this.local_http_opts).subscribe(data => {
            this.userService.serviceInterfaceToInformOfChanges().next(this.log_prefix);

        })
    }
    updateAllUserCommentsToRead(user_id){
        return this.http.post(this.bes.getBackendNotiAllCommentSetToRead(),{user_id}, this.local_http_opts).subscribe(data => {
        })
    }
    updateAllUserFollowToRead(user_id){
        return this.http.post(this.bes.getBackendNotiAllFollowSetToRead(),{user_id}, this.local_http_opts).subscribe(data => {
        })
    }
    getAllBoardsforLocalUser(){
        return this.http.get(this.bes.getBackendAllRelatedBoardsUrl(), this.local_http_opts);
    }
    startFollow(board_id, owner_id){
        return this.http.post(this.bes.startFollowBoard(),{board_id, owner_id}, this.local_http_opts).subscribe(followstart=>{
        })
    }
    stopFollow(board_id, owner_id){
        return this.http.post(this.bes.stopFollowBoard(),{board_id, owner_id}, this.local_http_opts).subscribe(followstop=>{
        })
    }
    getBoardComments(board_id){
        return this.http.post(this.bes.getBackendBoardComments(),{board_ids: [board_id]}, this.local_http_opts);
    }
    getBackendCommentLikeStatus(comment_id:string){
        return this.http.post(this.bes.getBackendBoardCommentsLikeStatus(),{comment_id}, this.local_http_opts);
    }
    getBackendCommentLikeStart(comment_id:string){
        return this.http.post(this.bes.getBackendBoardCommentsLikeStart(),{comment_id}, this.local_http_opts);
    }
    getBackendCommentLikeStop(comment_id:string){
        return this.http.post(this.bes.getBackendBoardCommentsLikeStop(),{comment_id}, this.local_http_opts);
    }
    getBackendDeleteComment(comment_id:string){
        let clone = this.local_http_opts;
        clone['body'] = {comment_ids: [comment_id]};
        return this.http.request('DELETE',this.bes.getBackendBoardDeleteComment(), clone );
    }
    getBackendDeleteBoard(board_id:string){
        let clone = this.local_http_opts;
        clone['body'] = {board_ids: [board_id]};
        return this.http.request('DELETE',this.bes.getBackendBoardDelete(), clone );
    }
    getBackendCommentwrite(board_id, message, owner_id){
        return this.http.post(this.bes.getBackendBoardwriteComment(),{board_id, message, owner_id}, this.local_http_opts);
    }
    getAllBoardsExplore(){
        return this.http.get(this.bes.getBackendBoardexplore(), this.local_http_opts);
    }
    getallFollowerForNotificationComponent(){
        return this.http.get(this.bes.getallFollowerForNotification(), this.local_http_opts);
    }
    getallCommentsForNotificationComponent(){
        return this.http.get(this.bes.getallCommentsForNotification(), this.local_http_opts);
    }
    registerNewUser(userName: string, userPass: string, userEmail: string){
        return this.http.post(this.bes.getBackendRegisterUser(),{userName, userPass, userEmail}, this.local_http_opts);
    }
    checkUsername(userName: string){
        return this.http.post(this.bes.getBackendCheckUsername(),{userName}, this.local_http_opts);
    }
    updateUserPassword(new_user_pass: string){
        return this.http.post(this.bes.getBackendUpdateUserPassword(),{new_user_pass}, this.local_http_opts);
    }

    updateUserBasicData(list_of_differences: Array<Object>):void{
        let data = {};
        list_of_differences.map(ele => {
            let key = Object.keys(ele)[0];
            let value = ele[key];
            switch (key) {

                case 'username':
                case 'user_name': {
                    data['user_name'] = value;
                    break;
                }
                case 'user_email':
                case 'email': {
                    data['user_email'] = value;
                    break;
                }
                case 'user_homepage':
                case 'homepage': {
                    data['user_homepage'] = value;
                    break;
                }
                case 'user_homepage':
                case 'homepage': {
                    data['user_homepage'] = value;
                    break;
                }
                case 'user_avatar_picture':
                case 'avatar_picute': {
                    data['user_avatar_picture'] = value;
                    break;
                }
                case 'user_country':
                case 'country': {
                    data['user_country'] = value;
                    break;
                }
                case 'user_city':
                case 'city': {
                    data['user_city'] = value;
                    break;
                }
                case 'user_zip':
                case 'zip': {
                    data['user_zip'] = value;
                    break;
                }
            }
        });
        let postData = {
            data
        };

        this.http.post(this.bes.getBackendUpdateUserBasics(), postData , this.local_http_opts)
            .subscribe(data=>{
                this.logger.info(this.log_prefix,"updated user basic data:",data);
                this.userService.serviceInterfaceToInformOfChanges().next(this.log_prefix);

            });
    }

    getNewFollowUnreadCount(){
        return this.http.get(this.bes.getnewFollowNotification(), this.local_http_opts)
    }
    getNewCommentUnreadCount(){
        return this.http.get(this.bes.getnewCommentNotificationCount(), this.local_http_opts)
    }
    getNewFollowNotification(){
        this.http.get(this.bes.getnewFollowNotification(), this.local_http_opts).subscribe(newfo=>{
            let count = newfo['number_of_follow_unread'];
            this.returnFollowerUnreadCount.emit(count);

        })
    }
    getNewCommetNotification(){
        this.http.get(this.bes.getnewCommentNotificationCount(), this.local_http_opts).subscribe(newfo=>{
            let count = newfo['number_of_comments_unread'];
            this.returnCommentUnreadCount.emit(count);

        })
    }
    public getNewfollowCount(){
        this.http.get(this.bes.getnewFollowNotification(), this.local_http_opts).subscribe(data => {
                const count = data['number_of_follow_unread'];
            });
    }
    public getFollowerUnreadCountEmitter(){
        return this.returnFollowerUnreadCount;
    }

    public getCommentUnreadCountEmitter(){
        return this.returnCommentUnreadCount;
    }
    public createBoard(board:backendApiInputCreateNewBoardWrapper){
        let lp=this.log_prefix+"createBoard:";
        return this.http.post(this.bes.getBackendCreateBoardUrl(),board, this.local_http_opts);
    }
    getAllTweetsForScreennames(search_user_target){
        return this.http.post(this.bes.getBackendGetAllTweets(), search_user_target , this.local_http_opts);
    }
    getAllTweetsForHashtags(search_via_hashtag){
        return this.http.post(this.bes.getBackendThirdPartyRestApiTwitterGetTweetsByHashtags(), search_via_hashtag , this.local_http_opts);
    }
    getCommentLikeStateCall(comment_id){
        return this.http.post(this.bes.getCommentLikeState(),{comment_id}, this.local_http_opts);
    }
    getFollowerFromBoardID(board_id){
        return this.http.post(this.bes.getFollowerFromBoard(),{board_id}, this.local_http_opts)
    }
    getJokes(){
        return this.http.get(this.bes.getJokesFromBE(), this.local_http_opts)
    }
    getPostForBoards(board_id){
        return this.http.post(this.bes.getPostForBoardsFromBE(),{board_id}, this.local_http_opts)
    }
    createPostForBoards(post_text, post_image, post_board_id, post_owner, gifisInside){
        return this.http.post(this.bes.createPostForBoards(),{post_text, post_image, post_board_id, post_owner, gifisInside}, this.local_http_opts)
    }
    createPostForBoardsMultimedia(formData:any){
        let modifiedHttpOpts = new HttpOptions(this.current_user_session);

        modifiedHttpOpts.headers = new HttpHeaders({
            // 'Content-Type': 'multipart/form-data; boundary=----------------------------531228270322210146706563\r\n',
            // "enctype": "multipart/form-data",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'PUT, GET, POST, DELETE, OPTIONS',
            'Authorization': "Bearer "+this.current_user_session.token
        })
        let {post_board_text} = formData;
        this.logger.info(this.log_prefix,"create post multimedia:",Object.keys(formData),"::",formData,"have text:",post_board_text);
        // modifiedHttpOpts.transformRequest = angular.identity
        this.http.post(this.bes.createPostForBoards(),formData, modifiedHttpOpts).subscribe(data => {
            this.returnCreateBoardPostIsDone.emit(true)
        })
    }
    getPostUploadState(){
        return this.returnCreateBoardPostIsDone;
    }
    getEmojisCall(){
        return this.http.get(this.bes.getEmojis(), this.local_http_opts)
    }
    sendContactMessageToWhooosh(user_contact_messages_user_id, user_contact_message_user_email, user_contact_message_user_name, user_contact_messages_text, user_contact_messages_subject){
        return this.http.post(this.bes.sendContactMessage(),{user_contact_messages_user_id, user_contact_message_user_email, user_contact_message_user_name, user_contact_messages_text, user_contact_messages_subject}, this.local_http_opts)
    }
    verifiedStatusCall(user_contact_messages_subject){
        return this.http.post(this.bes.verifiedStatus(),{user_contact_messages_subject}, this.local_http_opts)
    }
    boardPostLikeStartBes(boardpost_id, owner_id){
        return this.http.post(this.bes.boardPostLikeStart(),{boardpost_id, owner_id}, this.local_http_opts)
    }
    boardPostLikeStopBes(boardpost_id){
        return this.http.post(this.bes.boardPostLikeStop(),{boardpost_id}, this.local_http_opts)
    }
    boardPostLikeStatusBes(boardpost_id){
        return this.http.post(this.bes.boardPostLikeStatus(),{boardpost_id}, this.local_http_opts)
    }
    getAffiliteLinksForBoard(board_id){
        return this.http.post(this.bes.getAffiliteLinksForBoardFromBE(),{board_id}, this.local_http_opts)
    }
    getAllCollectionsFromUser(){
        return this.http.get(this.bes.getcollectiosFromUser(), this.local_http_opts)
    }
    createNewKollection(kollection_name){
        return this.http.post(this.bes.createNewKollection(),{kollection_name}, this.local_http_opts)
    }
    getStopKollektionRelation(kollection_id, board_id){
        return this.http.post(this.bes.getBackendStopKollektionRelation(),{kollection_id, board_id}, this.local_http_opts)
    }
    getStartKollektionRelation(kollection_id, board_id){
        return this.http.post(this.bes.getBackendStartKollektionRelation(),{kollection_id, board_id}, this.local_http_opts)
    }
    getStatusKollektionRelation(kollection_id, board_id){
        return this.http.post(this.bes.getBackendStatusKollektionRelation(),{kollection_id, board_id}, this.local_http_opts)
    }
    getGetAllKollektionRelation(kollection_id:number){
        return this.http.get(this.bes.getBackendGetAllKollektionRelation(kollection_id), this.local_http_opts)
    }
    getDeleteKollektion(kollection_id){
        return this.http.post(this.bes.getBackendDeleteKollektion(kollection_id), {kollection_id}, this.local_http_opts)
    }
    getDeleteboardPost(boardpost_id){
        return this.http.post(this.bes.getBackendDeleteboardPost(boardpost_id), {boardpost_id}, this.local_http_opts)
    }
    editBoard(board_id: number, board:EditExistingBoard, url){
        let lp=this.log_prefix+"editBoard:";
        return this.http.post(this.bes.getBackendBoardEditUrl(board_id),board, this.local_http_opts)

    }
    getuserContactMessages(){
        return this.http.get(this.bes.getuserContactMessages(), this.local_http_opts)
    }
    updateUserMessageStatus(user_contact_messages_id, user_contact_messages_status){
        return this.http.post(this.bes.getuserContactMessagesUpdateStatus(), {user_contact_messages_id, user_contact_messages_status}, this.local_http_opts)
    }
    createnewAffiliateLink(affiliate_board_name, affiliate_board_id, affiliate_link_path, affiliate_image_path, affiliate_description){
        return this.http.post(this.bes.createNewAffiliateLink(), {affiliate_board_name, affiliate_board_id, affiliate_link_path, affiliate_image_path, affiliate_description}, this.local_http_opts)
    }
    checkBoardname(board_name, ){
        return this.http.post(this.bes.checkBoardname(), {board_name}, this.local_http_opts)
    }
    getVibrantfromImage(board_image, ){
        return this.http.post(this.bes.getVibrantfromImage(), {board_image}, this.local_http_opts)
    }
    getTiktokProfil(user_profile, ){
        return this.http.post(this.bes.getTiktokProfil(), {user_profile}, this.local_http_opts)
    }
    getTiktokFeedsForProfil(user_id, ){
        return this.http.post(this.bes.getTiktokFeedsForProfil(), {user_id}, this.local_http_opts)
    }
    getTiktokFeedsViaHashtag(hash_tag, ){
        return this.http.post(this.bes.getTiktokFeedsViaHashtag(), {hash_tag}, this.local_http_opts)
    }
    resetUserPw(user_email){
        return this.http.post(this.bes.resetUserPassword(), {user_email}, this.local_http_opts)
    }
    getUserIdByToken(){
        return this.http.get(this.bes.getUserIdByToken(), this.local_http_opts)
    }
    getTiktokUserRapidapiCall(user_name){
        return this.http.post(this.bes.getTiktokUserRapidapi(), {user_name}, this.local_http_opts)
    }
    getTiktokUserFeedRapidapiCall(user_profile){
        return this.http.get(this.bes.getTiktokUserFeedRapidapi()+"?user_profile="+user_profile)
    }
    getTiktokHashtagFeedRapidapiCall(user_name){
        return this.http.post(this.bes.getTiktokHashtagFeedRapidapi(), {user_name}, this.local_http_opts)
    }
    searchbyBoardnameRequest(board_name){
        return this.http.post(this.bes.searchbyBoardname(), {board_name}, this.local_http_opts)
    }
    getFeedsFromFollowingBoardsRequest(user_id){
        return this.http.post(this.bes.getFeedsFromFollowingBoards(), {user_id}, this.local_http_opts)
    }
    videoUpload(filename){
        return this.http.post(this.bes.videoUpload(), {filename}, this.local_http_opts).subscribe(data=>{
        })
    }
    getTTUserRequest(user_profile){
        return this.http.get(this.bes.getTTUser()+"?user_profile="+user_profile)
    }
    getTTUserFeedRequest(user_profile){
        return this.http.get(this.bes.getTTUserFeed()+"?user_profile="+user_profile)
    }
    getSearchUserByUserNameRequest(user_name){
        return this.http.post(this.bes.getSearchUserByUserName(), {user_name}, this.local_http_opts)
    }
    getRelationRequests(user_relation_status){
        return this.http.post(this.bes.getRelationRequests(), {user_relation_status}, this.local_http_opts)
    }
    getCreateNewRelationRequests(user_id){
        return this.http.post(this.bes.createNewRelation(), {user_id}, this.local_http_opts)
    }
    getRelationFromMe(user_relation_status){
        return this.http.post(this.bes.getRelationFromMe(), {user_relation_status}, this.local_http_opts)
    }
    getDeleteRelationRequest(user_id){
        return this.http.post(this.bes.deleteRelation(), {user_id}, this.local_http_opts)
    }
    getDontAcceptRelationRequest(user_id){
        return this.http.post(this.bes.dontAcceptRelation(), {user_id}, this.local_http_opts)
    }
    getAcceptRelationRequest(user_id){
        return this.http.post(this.bes.acceptRelation(), {user_id}, this.local_http_opts)
    }
    getRelationUnreadCountRequest(){
        return this.http.get(this.bes.relation_unread_count(), this.local_http_opts)
    }
    getCheckUserHaveSendRelationRequest(user_id){
        return this.http.post(this.bes.checkUserHaveSendRelationRequest(), {user_id}, this.local_http_opts)
    }
    getCheckRelationStatusRequest(user_id){
        return this.http.post(this.bes.checkRelationStatus(), {user_id}, this.local_http_opts)
    }
    getUserFeedsInstaRequest(user_profile){
        return this.http.get(this.bes.getUserFeedsInsta()+"?user_profile="+user_profile)
    }
    getsearchUserInstaRequest(user_profile){
        return this.http.get(this.bes.getsearchUserInsta()+"?user_profile="+user_profile)
    }
    getYouHaveSendRelationRequestRequest(user_id){
        return this.http.post(this.bes.youHaveSendRelationRequest(), {user_id}, this.local_http_opts)
    }
    getUserMessageCountRequest(){
        return this.http.get(this.bes.getUserMessageCount(), this.local_http_opts)
    }
    getInstaUserFeedRapidapiRequest(user_name){
        return this.http.post(this.bes.getInstaUserFeedRapidapi(), {user_name}, this.local_http_opts)
    }
    getInstaSearchUserFeedRapidapiRequest(user_name){
        return this.http.post(this.bes.instaSearchUserFeedRapidapi(), {user_name}, this.local_http_opts)
    }
    getUserFeedByIdRapidapiRequest(user_name){
        return this.http.post(this.bes.getUserFeedByIdRapidapi(), {user_name}, this.local_http_opts)
    }
    getCancelDeleteAccountRequest(){
        return this.http.get(this.bes.getCancelDeleteAccount(),  this.local_http_opts)
    }
    getUserFeedSSovidRequest(user_profile){
        return this.http.get(this.bes.getUserFeedSSovid()+"?user_profile="+user_profile)
    }
    getUserSearchSSovidRequest(user_profile){
        return this.http.get(this.bes.getUserSearchSSovid()+"?user_profile="+user_profile)
    }
    getCheckIfBackupfeedExistRequest(board_id, social_media_provider_id){
        return this.http.post(this.bes.checkIfBackupfeedExist(), {board_id, social_media_provider_id}, this.local_http_opts)
    }
    getSaveSocialMediaFeedRequest(board_id, social_media_provider_id, backupFeed, googleFeed){
        return this.http.post(this.bes.saveSocialMediaFeed(), {board_id, social_media_provider_id, backupFeed, googleFeed}, this.local_http_opts)
    }
    getupdateBackupFeedRequest(board_id, social_media_provider_id, backupFeed, googleFeed){
        return this.http.post(this.bes.updateBackupFeed(), {board_id, social_media_provider_id, backupFeed, googleFeed}, this.local_http_opts)
    }
    getAllBoardBackupFeedsByBoardIdRequest(board_id){
        return this.http.post(this.bes.getAllBoardBackupFeedsByBoardId(), {board_id}, this.local_http_opts)
    }
    getAllBoardBackupFeedsByBoardIdAndProviderIdRequest(board_id, social_media_provider_id){
        return this.http.post(this.bes.getAllBoardBackupFeedsByBoardIdAndProviderId(), {board_id, social_media_provider_id}, this.local_http_opts)
    }
    getAllExistsAwardsRequest(){
        return this.http.get(this.bes.getAllExistsAwards(),  this.local_http_opts)
    }
    getAllAwardsForUserIdRequest(user_id){
        return this.http.post(this.bes.getAllAwardsForUserId(), {user_id}, this.local_http_opts)
    }
    getCheckAndWriteUserWithMostViewsOfBoardRequest(){
        return this.http.get(this.bes.checkAndWriteUserWithMostViewsOfBoard(),  this.local_http_opts)
    }
    getCheckAndWriteUserWithMostFollowerInBoardsRequest(){
        return this.http.get(this.bes.checkAndWriteUserWithMostFollowerInBoards(),  this.local_http_opts)
    }
    getCheckAndWriteUserWithMostCreatedBoardsRequest(){
        return this.http.get(this.bes.checkAndWriteUserWithMostCreatedBoards(),  this.local_http_opts)
    }
    getCheckAndWriteUserCreatetBoardAwardRequest(user_id){
        return this.http.post(this.bes.checkAndWriteUserCreatetBoardAward(), {user_id}, this.local_http_opts)
    }
    get_all_users_MSG_by_id_Request(){
        return this.http.get(this.bes.get_all_users_MSG_by_id(),  this.local_http_opts)
    }

    retrieveBoardAvatarUrlFromBackend(queryArgument?:string):Observable<string>{
        let lp=this.log_prefix+"retrieveBoardAvatarUrlFromBackend:"
        let urlTarget = this.bes.getRandomImageUrlForBoardAvatar();
        if(queryArgument != null && queryArgument != ""){
            urlTarget += "?prefix="+queryArgument;
        }
        this.logger.info(lp,"have url:",urlTarget);
        let returnObservable = new Observable<string>((observer)=>{
            this.http.get(urlTarget, this.local_http_opts).subscribe(data => {
                this.logger.info(lp,"have got data:",JSON.stringify(data));
                Object.keys(data).filter(key => key == "file").map(dataKey => {
                    this.logger.info(lp,"have got data:",typeof data[dataKey],data[dataKey]);
                    observer.next(data[dataKey]);
                })
            });
        })
        return returnObservable;
    }

    searchBoardbyTag(board_tag){
        return this.http.post(this.bes.searchBoardbyTag(), {board_tag},  this.local_http_opts)
    }
    searchFacebookProfiles(name){
        return this.http.post(this.bes.searchFacebookProfiles(), {name},  this.local_http_opts)
    }
    facebookProfileFeed(name){
        return this.http.post(this.bes.facebookProfileFeed(), {name},  this.local_http_opts)
    }
    instahashtagfeed(user_name){
        return this.http.post(this.bes.instahashtagfeed(), {user_name},  this.local_http_opts)
    }
    replyContactMessage(subject, msg, toEmail, parent_msg_id){
        return this.http.post(this.bes.replyContactMessage(), {subject, msg, toEmail, parent_msg_id},  this.local_http_opts)
    }
    getAllContactRequest(){
        return this.http.get(this.bes.getAllContactRequest(),  this.local_http_opts)
    }
    updateStatusFromKontaktMessages(status, id){
        return this.http.post(this.bes.updateStatusFromKontaktMessages(), {status, id},this.local_http_opts )
    }
    getAllKontaktMessages(){
        return this.http.get(this.bes.getAllKontaktMessages(),  this.local_http_opts)
    }
    getRandomsForHome(){
        return this.http.get(this.bes.getRandomsForHome(),  this.local_http_opts)
    }






}
